import Vue from 'vue';

export async function updateCollapseHeight(collapse) {
    if(!collapse.classList.contains('show')) {
        return;
    }
    collapse.style.height = `${collapse.scrollHeight}px`;
    collapse.classList.add('collapsing');
    await Vue.nextTick();
    collapse.style.height = `${collapse.scrollHeight}px`;
    const onEnd = () => {
        collapse.classList.remove('collapsing');
        collapse.style.height = '';
        collapse.removeEventListener('transitionend', onEnd);
    }
    collapse.addEventListener('transitionend', onEnd);
}
